import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@icp/components';
import { conditionNoNeedValue, IF_CONDITIONS } from '../utils';
import InputUI from '../../../InputElement/InputUI';
import SelectUI from '../../../SelectElement/SelectUI';
import { useEntity, useReadonly } from '../NodeContextProvider';

function ConditionLine(props) {
  const { index, operator, deleteAble, data, onDataChange, onDelete, onOperatorChange } = props;

  const { t } = useTranslation(['icp-flow']);
  const entityFields = useEntity().fields;
  const readonly = useReadonly();

  const { dataField, condition, value } = data;

  const handleFieldChange = (newDataField) => {
    onDataChange({ ...data, dataField: newDataField });
  };

  const handleConditionChange = (newCondition) => {
    onDataChange({ ...data, condition: newCondition });
  };

  const handleValueChange = (newValue) => {
    onDataChange({ ...data, value: newValue });
  };

  const handleDeleteCondition = () => {
    onDelete(data);
  };

  const noNeedValue = conditionNoNeedValue(condition);

  const filterOperator = (id) => {
    const list = [
      {
        id: 'AND',
        name: t('if.operator.and'),
      },
      {
        id: 'OR',
        name: t('if.operator.or'),
      },
    ];
    const res = list.find((ele) => ele.id === id);
    return res?.name ?? ' ';
  };

  return (
    <div className="icp-workflow-setting-condition-line">
      {index === 0 ? <div className="condition-operand">{t('if.title')}</div> : null}
      {index > 1 ? <div className="condition-operand">{filterOperator(operator)}</div> : null}
      {index === 1 ? (
        <div className="condition-operand">
          <SelectUI
            id="operator"
            value={operator}
            options={[
              {
                value: 'AND',
                label: t('if.operator.and'),
              },
              {
                value: 'OR',
                label: t('if.operator.or'),
              },
            ]}
            onChange={onOperatorChange}
          />
        </div>
      ) : null}
      {/* <div className="condition-form"> */}
      <SelectUI
        id="dataField"
        value={dataField ? { value: dataField } : null}
        options={entityFields.map((item) => ({ value: item.token, label: item.name }))}
        onChange={handleFieldChange}
        readonly={readonly}
        componentProps={{
          placeholder: t('if.data-field'),
        }}
        fieldTitleProps={{ showColon: true }}
      />
      <SelectUI
        id="condition"
        value={condition ? { value: condition } : null}
        options={IF_CONDITIONS.map((id) => ({ value: id, label: t(`if.conditions.${id}`) }))}
        onChange={handleConditionChange}
        readonly={readonly}
        componentProps={{
          placeholder: t('if.condition'),
        }}
        fieldTitleProps={{ showColon: true }}
      />
      {!noNeedValue ? (
        <InputUI
          id="value"
          value={value}
          onChange={handleValueChange}
          readonly={readonly}
          componentProps={{
            placeholder: t('if.value'),
          }}
          fieldTitleProps={{ showColon: true }}
        />
      ) : null}
      {/* </div> */}
      {deleteAble && !readonly ? (
        <button className="icp-workflow-delete-button" onClick={handleDeleteCondition}>
          <Icon name="oct:x" size={10} />
        </button>
      ) : null}
    </div>
  );
}

ConditionLine.propTypes = {
  index: PropTypes.number,
  operator: PropTypes.string,
  deleteAble: PropTypes.bool,
  data: PropTypes.shape({
    dataField: PropTypes.string,
    condition: PropTypes.oneOf(IF_CONDITIONS),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onDataChange: PropTypes.func,
  onDelete: PropTypes.func,
  onOperatorChange: PropTypes.func,
};

export default ConditionLine;
